import type { UnitRight } from '../textInput/TextInput'

// In cosma v9, the textInput or numberInput no longer has the unit with mapping embed in the components. This helper function is to reserve the behaviour without all components that using textInput or numberInput.
const UNIT_SYMBOLS: Partial<Record<UnitRight, string>> = {
  percent: '%',
  sqm: 'm²',
  eur: '€',
  eurPerSqm: '€/m²',
  minutes: 'min',
  kilowattHour: 'kWh',
  kgPerSqm: 'kg/m²',
  kiloVoltAmpere: 'kVA',
  meters: 'm',
}

export const mapUnitTypeToUnitSymbol = (unitType?: UnitRight): string | undefined => {
  if (!unitType || unitType === 'none') {
    return undefined
  }

  return UNIT_SYMBOLS[unitType] ?? unitType
}
